import styled from "styled-components";
import colors from "../../../../css/colors";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export const QuestionMarkIcon = styled(ExclamationCircleOutlined)`
  color: ${colors.YELLOW};
  cursor: pointer;
`;
